import { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';

/** Matches the platform shell content wrapper `p-6` bottom padding. */
const PAGE_BOTTOM_GAP_PX = 24;

/**
 * Measures the element's top edge and fills down to the viewport bottom,
 * minus page bottom padding. Recalculates after layout and on window resize.
 */
export const useFillAvailableHeight = (enabled: boolean) => {
    const ref = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState<number>();

    const measure = useCallback(() => {
        if (!enabled || !ref.current) return;
        const next = Math.max(0, Math.floor(window.innerHeight - ref.current.getBoundingClientRect().top - PAGE_BOTTOM_GAP_PX));
        setHeight((prev) => (prev === next ? prev : next));
    }, [enabled]);

    useLayoutEffect(measure);

    useEffect(() => {
        if (!enabled) return;
        window.addEventListener('resize', measure);
        return () => window.removeEventListener('resize', measure);
    }, [enabled, measure]);

    return { ref, height };
};
